module.exports = __webpack_public_path__ + "icon-fence-wirestrength.svg?1ab6f9aa23f03f0a54e41d0cb6425920";